import { Button, Card, Input, Modal, Table } from "antd";
import "bootstrap-icons/font/bootstrap-icons.css";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { CSVLink } from "react-csv";
import { useDispatch, useSelector } from "react-redux";
import { getUserDevices, removeBiometric } from "../../redux/rtk/features/user/userSlice";
import UserPrivateComponent from "../PrivateRoutes/UserPrivateComponent";
import ColVisibilityDropdown from "../Shared/ColVisibilityDropdown";
import { CsvLinkBtn } from "../UI/CsvLinkBtn";

// Date functionalities
let startdate = dayjs().startOf("month");
let enddate = dayjs().endOf("month");

function CustomTable({ list, total }) {
    const dispatch = useDispatch();
    const [columnsToShow, setColumnsToShow] = useState([]);
    const [selectedRecord, setSelectedRecord] = useState(null);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [searchText, setSearchText] = useState("");
    const [filteredData, setFilteredData] = useState([]);

    const columns = [
        {
            id: 1,
            title: "Name",
            key: "name",
            render: (text, record) => (
                <span>{`${record.user.FirstName} ${record.user.astName}`}</span>
            ),
        },
        // {
        //     id: 3,
        //     title: "Unique Identifier",
        //     dataIndex: "unique_identifier",
        //     key: "unique_identifier",
        // },
        {
            id: 4,
            title: "Remove Biometric",
            key: "remove_biometric",
            render: (text, record) => (
                <Button
                    type="danger"
                    onClick={() => {
                        setSelectedRecord(record);
                        setIsModalVisible(true);
                    }}
                >
                    Remove
                </Button>
            ),
        },
    ];

    useEffect(() => {
        setColumnsToShow(columns);
    }, []);

    useEffect(() => {
        if (searchText) {
            const filtered = list.filter((item) =>
                `${item.user.firstName} ${item.user.lastName}`
                    .toLowerCase()
                    .includes(searchText.toLowerCase())
            );
            setFilteredData(filtered);
        } else {
            setFilteredData(list);
        }
    }, [searchText, list]);

    const handleOk = () => {
        if (selectedRecord) {
            dispatch(removeBiometric(selectedRecord.userDeviceId));
        }
        setIsModalVisible(false);
    };

    const handleCancel = () => {
        setIsModalVisible(false);
    };

    const addKeys = (arr) => arr.map((i) => ({ ...i, key: i.userDeviceId }));

    const CSVlist = Array.isArray(filteredData) ? filteredData.map((i) => ({
        ...i,
        biometric: i?.biometric?.name,
        credit: i?.credit?.name,
    })) : [];

    console.log('CSV Data:', CSVlist);

    return (
        <div>
            <div className='flex mt-4 mb-4 mr-4 justify-between items-center'>
                <Input
                    placeholder="Search by name"
                    onChange={(e) => setSearchText(e.target.value)}
                    style={{ width: 300, marginRight: 16 }}
                />
                <div className='flex items-center'>
                    <CsvLinkBtn>
                        <CSVLink data={CSVlist} filename='user.csv'>
                            Download CSV
                        </CSVLink>
                    </CsvLinkBtn>
                    <div style={{ marginLeft: 16 }}>
                        {list && (
                            <ColVisibilityDropdown
                                options={columns}
                                columns={columns}
                                columnsToShowHandler={(val) => setColumnsToShow(val)}
                            />
                        )}
                    </div>
                </div>
            </div>
            <Table
                scroll={{ x: true }}
                loading={!list}
                pagination={{
                    defaultPageSize: 20,
                    pageSizeOptions: [10, 20, 50, 100, 200],
                    showSizeChanger: true,
                    total: total,
                    onChange: () => {
                        dispatch(getUserDevices({}));
                    },
                }}
                columns={columnsToShow}
                dataSource={filteredData ? addKeys(filteredData) : []}
            />
            <Modal
                title="Confirm Removal"
                visible={isModalVisible}
                onOk={handleOk}
                onCancel={handleCancel}
            >
                <p>Are you sure you want to remove the biometric data for {selectedRecord?.user?.firstName} {selectedRecord?.user?.lastName}?</p>
            </Modal>
        </div>
    );
}

const RemoveBiometric = () => {
    const dispatch = useDispatch();
    const userDeviceDetails = useSelector((state) => state.users.userDeviceDetails);

    useEffect(() => {
        dispatch(getUserDevices());
    }, [dispatch]);

    return (
        <UserPrivateComponent permission={"readAll-user"}>
            <Card className=''>
                <div className='card-title flex justify-between mr-4'>
                    <h5 className='text-xl txt-color-2'>
                        <span>Remove Biometric</span>
                    </h5>
                </div>
                <CustomTable
                    list={userDeviceDetails}
                    startdate={startdate}
                    enddate={enddate}
                />
            </Card>
        </UserPrivateComponent>
    );
};

export default RemoveBiometric;
